/* eslint-disable no-console */
import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

import { CustomPosthogEvent } from '../types/customPosthogEvent';
import { useYears } from './use-years';

const useCustomPosthogEvent = () => {
  const posthog = usePostHog();
  const { selectedYear } = useYears();

  const trackEvent = useCallback(
    (eventName: CustomPosthogEvent, properties = {}) => {
      if (eventName && posthog) {
        posthog.capture(eventName, { ...properties, reporting_year: selectedYear });
      }
    },
    [posthog, selectedYear]
  );

  return { trackEvent };
};

export default useCustomPosthogEvent;
